































































































import {
  LicenceControllerApi,
  LicenceSummary,
  WildlifeCategoryControllerApi,
} from "@/api/lms";
import { manageLoading } from "@/utils/SnackbarUtil";
import Vue from "vue";
import Component from "vue-class-component";
import {
  basicChartDataset,
  groupRegionToStackBarChart,
} from "@/utils/ChartUtil";
import BarChart from "@/components/charts/BarChart.vue";
import PolarAreaChart from "@/components/charts/PolarAreaChart.vue";
import { licenceStore } from "@/store/modules/LicenceStore";

import ReportSelector from "@/components/reports/ReportSelector.vue";

@Component({
  components: {
    BarChart,
    PolarAreaChart,
    ReportSelector,
  },
})
export default class LicenceReport extends Vue {
  api = new LicenceControllerApi();
  wildlifeApi = new WildlifeCategoryControllerApi();

  summary: LicenceSummary | null = null;
  categories: string[] = [];

  from = "";
  to = "";

  stackedBarChartOptions = {
    scales: {
      yAxes: [
        {
          stacked: true,
        },
      ],
      xAxes: [
        {
          stacked: true,
        },
      ],
    },
  };

  selectedLicenceType = 1;

  reports = ["LICENCES", "LICENCE_HARVEST_AREAS", "LICENCE_CATEGORIES"];

  async mounted() {
    manageLoading("Loading Wildlife Categories", async () => {
      const response = await this.wildlifeApi.getCategories();
      this.categories = response.data.map((cat) => cat.category);
    });
    await this.refresh();
  }

  get licenceTypes() {
    return licenceStore.licenceTypes;
  }

  get regionData() {
    return {
      labels: this.summary?.region.map((item) => `Region ${item.group}`),
      datasets: basicChartDataset(this.summary?.region),
    };
  }

  get licenceTypeData() {
    const total = this.summary?.licenceType
      .map((item) => item.count)
      .reduce((total, value) => Number(total) + Number(value), 0);
    return {
      labels: this.summary?.licenceType.map(
        (item) =>
          `${item.group} (${Math.round(
            (Number(item.count) / Number(total)) * 100
          )}%)`
      ),
      datasets: basicChartDataset(this.summary?.licenceType),
    };
  }

  get categoryData() {
    const categories = this.categoriesWithUnknown();
    const total = categories
      ?.map((item) => item.count)
      .reduce((total, value) => Number(total) + Number(value), 0);
    return {
      labels: categories
        ? categories.map(
            (item) =>
              `${item.group} (${Math.round(
                (Number(item.count) / Number(total)) * 100
              )}%)`
          )
        : [],
      datasets: basicChartDataset(categories),
    };
  }

  get classData() {
    const total = this.summary?.licenceClass
      .map((item) => item.count)
      .reduce((total, value) => Number(total) + Number(value), 0);
    return {
      labels: this.summary?.licenceClass.map(
        (item) =>
          `${item.group} (${Math.round(
            (Number(item.count) / Number(total)) * 100
          )}%)`
      ),
      datasets: basicChartDataset(this.summary?.licenceClass),
    };
  }

  get categoryTypeByRegionData() {
    const dataset = this.summary?.categoryByRegion;
    const groups = this.categoriesWithUnknown()?.map((cat) => cat.group);
    if (!groups || !dataset) return null;
    const result = groupRegionToStackBarChart(
      groups,
      dataset?.map((cat) => {
        return this.categories.includes(String(cat.group))
          ? cat
          : { ...cat, group: "UNKNOWN" };
      })
    );
    return result;
  }

  get licenceTypeByRegionData() {
    const groups = this.summary?.licenceType.map((item) => item.group);
    if (!groups || !this.summary?.licenceTypeByRegion) return null;
    return groupRegionToStackBarChart(
      groups,
      this.summary?.licenceTypeByRegion
    );
  }

  refresh() {
    manageLoading("Loading Licence Summary", async () => {
      const response = await this.api.getSummary(
        this.from,
        this.to,
        String(this.selectedLicenceType)
      );
      this.summary = response.data;
    });
  }

  categoriesWithUnknown() {
    const knownCategories = this.summary?.category.filter((cat) =>
      this.categories.includes(String(cat.group))
    );
    const unknownCategory = this.summary?.category
      .filter((cat) => !this.categories.includes(String(cat.group)))
      .reduce(
        (prev, curr) => ({
          group: "UNKNOWN",
          count: Number(prev.count) + Number(curr.count),
        }),
        { group: "", count: 0 }
      );
    if (unknownCategory) knownCategories?.push(unknownCategory);
    return knownCategories;
  }
}
